import React from 'react'
import {
  Box, ImageLoader,
} from '@usap/uicomponents'
import SetKitDisplay from '../../../SetKitDisplay'
import { ItemDetailWrapper, ItemDetail, BrandName, ImageWrapper, ReturnItemDetail, ConfirmQty} from '../../rmaDetailModule/lifetimeReplacement/style/LifetimeReplacementWmo.css'

const ConfirmationOrderItemWmo = ({
  orderItems,
  isDesktop,
}) => {
  return (
    <>
      {orderItems.map((items, i) => (
        <ItemDetailWrapper>
          <ImageWrapper>
              <ImageLoader
                  key={`RMA${items.order_item_id}`}
                  width="100%"
                  height="100%"
                  src={items.ImageURL}
                  fit="contain"
                  alt={items.sku_title}
                  cloudinaryParams="h_125,w_125"
                  fallback="https://cld.partsimg.com/image/upload/noimage.jpg"
              />
              <ConfirmQty className='confirmQty'>Qty:{items.returnQty}</ConfirmQty>
          </ImageWrapper>

          <ItemDetail>
            <div>
                <BrandName>{items.brandText}</BrandName>®&nbsp;
                <span>{items.sku_title}</span>
            </div>
            <ReturnItemDetail>
                <div>Part Number: ${items.sku}</div>
                <div>Unit Price: ${parseFloat(items.list_price).toFixed(2)}</div>
            </ReturnItemDetail>

            <div className="itemTotal">
              Item Total: $
              {(parseFloat(items.list_price) * items.returnQty).toFixed(2)}
            </div>

              {isDesktop && items.parentSku && (
                  <Box key={`parentSku${items.order_item_id}`} pad={{ right: '16px', top: '16px' }}>
                      <SetKitDisplay
                          key={`hparentSKU${items.order_item_id}`}
                          parentSku={items.parentSku}
                          showPartNumber={false}
                          isWmoEnabled
                      />
                  </Box>
              )}
          </ItemDetail>
        </ItemDetailWrapper>
      ))}
    </>
  )
}

export default ConfirmationOrderItemWmo
